import styled from 'styled-components'

export const StResultTableWrapper = styled.div`
  width: 900px;
`

export const StTempPagenation = styled.div`
  width: 100%;
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
`

export const StTempButtonArea = styled(StTempPagenation)`
  margin-bottom: 40px;
  justify-content: flex-start;
`
